const getEnvironment = () => {
  const hostname = window.location.hostname;

  if (hostname.includes("localhost")) {
    return "dev";
  }
  if (hostname.includes("attendee-dev.connect.eventshq.com")) {
    return "dev";
  }
  if (hostname.includes("attendee-stage.connect.eventshq.com")) {
    return "stage";
  }
  return "prod";
};

const environment = getEnvironment();

const config = {
  dev: {
    apiBaseUrl: "https://api-dev.swap.eventshq.com/attendeeconnect",
    digitalBackpackBaseUrl: "https://test-hub.cdsreg.com",
  },
  stage: {
    apiBaseUrl: "https://api-stage.swap.eventshq.com/attendeeconnect",
    digitalBackpackBaseUrl: "https://test-hub.cdsreg.com",
  },
  prod: {
    apiBaseUrl: "https://api.swap.eventshq.com/attendeeconnect",
    digitalBackpackBaseUrl: "https://hub.cdsreg.com",
  },
};

export const API_BASE_URL = config[environment].apiBaseUrl;
export const DIGITAL_BACKPACK_BASE_URL =
  config[environment].digitalBackpackBaseUrl;
export const ENVIRONMENT = environment;
